<template>
  <div class="template">
    <ConceptionDesktop class="template__Desktop" />
    <ConceptionMobile class="template__Mobile" />
  </div>
</template>

<script>
import ConceptionDesktop from '@/components/services/Conception/ConceptionDesktop.vue'
import ConceptionMobile from '@/components/services/Conception/ConceptionMobile.vue'
export default {
  name: 'ConceptionView',
  components: {
    ConceptionDesktop,
    ConceptionMobile
  }
}
</script>


<style lang="scss">


.template__Desktop {
  display: none;
}

.template__Mobile {
  display: block;
}

@media screen and (min-width: 1024px) {
  .template__Desktop {
    display: block;
  }

  .template__Mobile {
    display: none;
  }
}
</style>